import { render, staticRenderFns } from "./TkScrollToTopBar.vue?vue&type=template&id=587881f2&"
import script from "./TkScrollToTopBar.vue?vue&type=script&lang=js&"
export * from "./TkScrollToTopBar.vue?vue&type=script&lang=js&"
import style0 from "./TkScrollToTopBar.vue?vue&type=style&index=0&id=587881f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports